import { createFileRoute } from "@tanstack/react-router";

import { ToolsIndex } from "../components/tools/ToolsIndex";
import { documentHeaders } from "../lib/seo";
import { toolsIndexHead } from "../lib/tools/head";
import { loadToolCopy, TOOLS, toolPath } from "../lib/tools/index";
import { TOOLS_UI } from "../lib/tools/ui";

/** The tools hub in English, at `/tools`. */
export const Route = createFileRoute("/tools/")({
  loader: () => loadToolCopy("en"),
  headers: documentHeaders,
  head: ({ loaderData }) =>
    loaderData
      ? toolsIndexHead(
          "en",
          TOOLS_UI.en,
          TOOLS.map((tool) => ({
            name: loaderData[tool.slug].h1,
            path: toolPath(tool.slug, "en"),
          })),
        )
      : {},
  component: EnglishToolsIndex,
});

function EnglishToolsIndex() {
  const copy = Route.useLoaderData();
  return <ToolsIndex lang="en" ui={TOOLS_UI.en} copy={copy} />;
}
